const authTheme = {
    auth: {
        container: {
            maxWidth: 480,
        },
    },
};

export default authTheme;
